import React, {useRef, useEffect, useState} from "react";
import Header from "../../components/Header";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import "./Profile.scss";
import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import countryList from "../../assets/countryList.json";
import Button from "react-bootstrap/Button";
import ProfileComponent from "../../components/Profile/ProfileComponent";

function Profile() {
    return (
        <div>
            <Header/>
            <div className="container container-profile" style={{paddingTop: 86, minHeight: "100vh"}}>
                <div className="row">
                    <div className="col-md-4 mb-4">
                       <ProfileComponent/>
                    </div>
                    <div className="col-md-8 mb-4">
                        <div className="card ">
                            <div className="card-body">
                                <h4>Modifica dati</h4>
                                <Form>
                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" placeholder="Inserisci email"/>
                                    </Form.Group>

                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="firstname">
                                                <Form.Label>Nome</Form.Label>
                                                <Form.Control type="text" placeholder="Nome"/>

                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" controlId="lastname">
                                                <Form.Label>Cognome</Form.Label>
                                                <Form.Control type="text" placeholder="Cognome"/>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Form.Group className="mb-3" controlId="phone">
                                        <Form.Label>Telefono</Form.Label>
                                        <Form.Control type="phone" placeholder="Inserisci il numero di telefono"/>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="country">
                                        <Form.Label>Paese</Form.Label>
                                        <Form.Select aria-label="Default select example">
                                            <option>Seleziona il paese</option>
                                            {countryList.map((item) => (
                                                <option key={item.code} value={item.name}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <div className="d-flex justify-content-center">
                                        <Button className={"btn-orange"} type="submit">Aggiorna dati</Button>
                                    </div>
                                </Form>
                                <hr/>
                                <h4>Modifica password</h4>
                                <Form>
                                    <Form.Group className="mb-3" controlId="password">
                                        <Form.Label>Vecchia password</Form.Label>
                                        <Form.Control type="password" placeholder="Vecchia password"/>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="password">
                                        <Form.Label>Nuova password</Form.Label>
                                        <Form.Control type="password" placeholder="Nuova password"/>
                                        <Form.Text className="text-muted">
                                            <small className="text-muted">La password deve contenere almeno 8
                                                caratteri</small><br/>
                                            <small className="text-muted">La password deve contenere almeno un carattere
                                                MAIUSCOLO</small><br/>
                                            <small className="text-muted">La password deve contenere almeno un
                                                numero</small>
                                        </Form.Text>
                                    </Form.Group>
                                    <div className="d-flex justify-content-center">
                                        <Button className={"btn-orange"} type="submit">Aggiorna password</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Profile;